import * as React from "react"
import {Box} from "@mui/material";
import {ButtonSeeker, IconSeeker, ModalSeeker} from "@ui-seeker/core";

import {useMatcherSkuImageComparisonNavigator} from "../../@hooks";
import {matcherSKUImageComparatorModalData} from "../../@signals";
import MatcherSkuImageComparisonModalContainer from "./Container";
import MatcherSkuImageComparisonModalCounter from "./Counter";
import MatcherSkuImageComparisonModalArrow from "./Arrow";


export default function MatcherSkuImageComparisonModal({  brandOptions=[], setSelectedSKU, saveMapping  }) {
	const { isOpen, numOptions, localIndex, handleNavigateLeft, handleNavigateRight } = useMatcherSkuImageComparisonNavigator(brandOptions, setSelectedSKU)

	return <ModalSeeker
		hideActions
		isOpen={isOpen}
		title={matcherSKUImageComparatorModalData.value.title}
		controller={() => matcherSKUImageComparatorModalData.value = {}}
		containerProps={{ fullScreen: true }}
	>
		<Box
			maxWidth={1}
			mx="auto"
			p={2}
		>
			<Box display="flex" flexDirection="column" gap={2}>
				<Box display="flex" alignItems="center" justifyContent="space-between" width={1}>
					<MatcherSkuImageComparisonModalCounter
						numOptions={numOptions}
						localIndex={localIndex}
					/>

					<ButtonSeeker
						color="success"
						startIcon={<IconSeeker icon="badge-check" />}
						onClick={() => {
							saveMapping?.()
							matcherSKUImageComparatorModalData.value = {}
						}}
					>
						Validate
					</ButtonSeeker>
				</Box>


				<Box
					display="flex"
					gap={2}
					alignItems="stretch"
					justifyContent="center"
					height="75vh"
					sx={{ position: 'relative' }}
				>
					<MatcherSkuImageComparisonModalArrow
						orientation="left"
						brandOptionsLength={numOptions}
						localIndex={localIndex}
						onNavigate={handleNavigateLeft}
					/>
					<MatcherSkuImageComparisonModalArrow
						orientation="right"
						brandOptionsLength={numOptions}
						localIndex={localIndex}
						onNavigate={handleNavigateRight}
					/>
					<MatcherSkuImageComparisonModalContainer
						fullURL={matcherSKUImageComparatorModalData.value?.fullUrlLeft}
						url={matcherSKUImageComparatorModalData.value.urlLeft}
						label="Target"
						labelColor="default"
					/>
					<MatcherSkuImageComparisonModalContainer
						fullURL={matcherSKUImageComparatorModalData.value?.fullUrlRight}
						url={matcherSKUImageComparatorModalData.value.urlRight}
						label="Selected"
						labelColor="primary"
					/>
				</Box>
			</Box>
		</Box>
	</ModalSeeker>
}
